import {
  MakeACourseEducatorImage,
  MarketYourBookImage,
  PublishBookEducatorImage,
} from 'assets';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Card, { ICard } from '@/components/Partnership/Common/Card';
import Layout from '@/components/Partnership/Common/Card/Layout';
import Header from '@/components/Partnership/Common/Header';
interface Props {
  className?: string;
}
const ForEducatorsSection: FC<Props> = ({ className }) => {
  const list: ICard[] = [
    {
      id: 1,
      title: 'Market your Business (Offline)',
      button: {
        link: 'https://educationmarketing.in/offline-class-marketing',
        text: 'Contact Us →',
      },
      image: MarketYourBookImage,
      pointers: [
        'Increase visibility for coaching centers, institutes, and educators',
        'Build credibility through books and offline promotion',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 2,
      title: 'List Your Course',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: MakeACourseEducatorImage,
      pointers: [
        'Convert expertise into structured courses',
        'End-to-end content & launch support',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 3,
      title: 'Publish Books',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: PublishBookEducatorImage,
      pointers: [
        'Turn your teaching material into published learning books',
        'Reach students through structured, curriculum-ready content',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
  ];
  return (
    <div className={twMerge('', className)}>
      <Header title='For Educators' className='md:pb-4 mb-[18px]' />
      <Layout>
        {list.map((i) => (
          <Card key={i.id} card={i} />
        ))}
      </Layout>
    </div>
  );
};

export default ForEducatorsSection;
